import { now } from "utils/DateUtils";
import { tickColor, tooltipPadding } from '../../../shared/graphs/utils';

export const renderData = (data, DAYS, valueFunction) => {
    return {
        labels: DAYS(),
        datasets: [
            {
                label: 'Actual',
                data: data ? data.map(valueFunction) : [],
                fill: false,
                backgroundColor: 'rgb(82 134 236)',
                yAxisID: 'y',
                xAxisID: 'x',
                pointRadius: 10,
                borderWidth: 2,
                barThickness: 10,
                categoryPercentage: 1,
                barPercentage: 5,
                borderRadius: Number.MAX_VALUE,
                borderSkipped: true,
            }
        ]
    }
}

export const renderOptions = (formatter, suggestedMax, isMobile, swapped) => {
    return {
        plugins: {
            autocolors: false,
            legend: {
                display: false
            },
            tooltip: {
                backgroundColor: 'rgba(255,255,255,1)',
                titleColor: '#142643',
                bodyColor: '#142643',
                footerColor: '#142643',
                padding: tooltipPadding,
                filter: function (tooltipItem) {
                    return tooltipItem.datasetIndex === 0;
                },
                callbacks: {
                    title: function(item, data) {
                        if (item.length) {
                            let d = now();
                            d.set({ 'date': item[0].label });
                            return d.format('MMMM Do');
                        }
                    },
                    label: function(item, data) {
                        return formatter(item.raw);
                    }
                },
                displayColors: false
            }
        },
        responsive: true,
        maintainAspectRatio: isMobile,
        layout: {
            padding: {
                left: 0,
                top: isMobile ? 25 : 40, // @NOTE: probably better to reduce rather than mobile padding changes on the menu
            }
        },
        scales: {
            y: {
                axis: 'y',
                id: 'y',
                position: 'left',
                title: {
                    display: false,
                },
                drawTicks: true,
                drawBorder: false,
                bounds: 'ticks',
                grid: {
                    borderColor: 'rgba(0,0,0,0)',
                },
                unitStepSize: 1,
                ticks: {
                    padding: 0,
                    offset: false,
                    autoSkip: false, // @NOTE: Show every day
                    fontColor: tickColor,
                    maxRotation: 0,
                    color: tickColor,
                    textStrokeColor: tickColor,
                    callback: (value, index, values) => {
                        if (value < 9) {
                            return (value+1).toString() + "  ";
                        } else {
                            return (value+1).toString()
                        }
                    },
                    font: {
                        size: 12
                    },
                },
                // afterFit: (scale) => afterScaleFit(scale) // @NOTE: Throws off the padding/alignment
            },
            x: {
                id: 'x',
                axis: 'x',
                position: 'left',
                drawTicks: true,
                drawBorder: false,
                offset: true,
                grid: {
                    display: false,
                    borderColor: 'rgba(255,255,255,0)',
                    tickLength: 10
                },
                ticks: {
                    autoSkip: false,
                    min: 0,
                    max: 5000,
                    display: false, // @NOTE: Hide the x $ values
                    fontColor: 'rgb(0, 255, 0, 0)',
                    color: 'rgb(0, 255, 0, 0)',
                },
                // @NOTE: Alternative way to draw the vertical lines
                /*
                ,afterBuildTicks: function(scale) {
                    scale.ticks = [{value: averageGoal}, {value: revenueGoal}];
                    return;
                },
                */
                beforeUpdate: function(oScale) {
                    return;
                },
                // suggestedMax: suggestedMax
            }
        },
        indexAxis: 'y',
        valueFormatter: formatter,
        swapped,
        isMobile,
    }
}